export const getWrapperStyles = align => ({
  display: 'flex',
  width: '100%',
  gap: '4px',
  justifyContent: align,
  alignItems: 'center',

  '&.MuiTableSortLabel-root': {
    '&:hover': {
      color: 'inherit',
    },
    '&.Mui-active': {
      color: 'inherit',
    },
  },
});

export const iconWrapperStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
};

export const tooltipIconStyles = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: 'text.secondary',
  cursor: 'default',
};

export const getFilterWrapperStyles = align => ({
  ...getWrapperStyles(align),

  '& .column-filter-icon': {
    opacity: 0,
    transition: 'opacity 0.2s ease',
  },

  '& .column-filter-icon.filter-active': {
    opacity: 1,
  },

  '&:hover .column-filter-icon': {
    opacity: 1,
  },
});
